import { normalize } from 'normalizr';

import {
  type AssetsHttpGetByObjectTypeByObjectIdSharesByShareIdUsersQuery,
  type AssetsShareUserSchemaWithId,
  httpDeleteByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId,
  httpGetByObjectTypeByObjectIdSharesByShareIdUsers,
  httpPostByObjectTypeByObjectIdSharesByShareIdUsers,
} from '@iconik-io/iconik-api/src/services/assets';
import { entitySchemas } from '@iconik-io/shared-lib/src/redux/entities/schemas';
import {
  deleteNormalizedEntity,
  updateEntities,
} from '@iconik-io/shared-lib/src/redux/entities/slice';

import type { AppDispatch } from '../../store/types';
import { deleteShareUserId, setShareUserIds } from './slice';

export function getShareUsers(
  objectType: string,
  objectId: string,
  shareId: string,
  data: AssetsHttpGetByObjectTypeByObjectIdSharesByShareIdUsersQuery = {},
  lastId?: string,
) {
  return (dispatch: AppDispatch): Promise<string[]> =>
    dispatch(
      httpGetByObjectTypeByObjectIdSharesByShareIdUsers(
        objectType,
        objectId,
        shareId,
        data,
      ),
    ).then(async (response) => {
      let userIds: string[] = [];
      if (response.body.objects.length === 10) {
        const newLastId =
          response.body.objects[response.body.objects.length - 1].id;
        const params = { last_id: newLastId };
        if (lastId !== newLastId) {
          userIds = await dispatch(
            getShareUsers(objectType, objectId, shareId, params, newLastId),
          );
        }
      }
      const result = normalize(response.body.objects, [
        entitySchemas.share_users,
      ]);
      dispatch(updateEntities(result.entities));
      const allUserIds = result.result.concat(userIds);
      if (lastId === undefined) {
        dispatch(setShareUserIds({ shareId, userIds: allUserIds }));
      }
      return allUserIds;
    });
}

export function deleteShareUsers(shareUsers: AssetsShareUserSchemaWithId[]) {
  return (dispatch: AppDispatch): Promise<void> =>
    Promise.all(
      shareUsers.map((shareUser) => {
        if (
          !shareUser.object_type ||
          !shareUser.object_id ||
          !shareUser.share_id
        ) {
          return Promise.reject();
        }
        return dispatch(
          httpDeleteByObjectTypeByObjectIdSharesByShareIdUsersByShareUserId(
            shareUser.object_type,
            shareUser.object_id,
            shareUser.share_id,
            shareUser.id,
          ),
        );
      }),
    ).then(() => {
      shareUsers.forEach((shareUser) => {
        dispatch(
          deleteNormalizedEntity({ key: 'share_users', id: shareUser.id }),
        );
        if (shareUser.share_id) {
          dispatch(
            deleteShareUserId({
              shareId: shareUser.share_id,
              userId: shareUser.id,
            }),
          );
        }
      });
    });
}

type CreatedShareUserData = {
  object_type: string;
  object_id: string;
  share_id: string;
  email: string;
};
export function addShareUsers(shareUsers: CreatedShareUserData[]) {
  return (dispatch: AppDispatch) =>
    Promise.all(
      shareUsers.map((shareUser) =>
        dispatch(
          httpPostByObjectTypeByObjectIdSharesByShareIdUsers(
            shareUser.object_type,
            shareUser.object_id,
            shareUser.share_id,
            { email: shareUser.email },
          ),
        ),
      ),
    );
}
